// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_eeec2b1e","isActive":"_2a287b5b","item":"_794c2a18","close":"_3163d59b","content":"_fce20084","title":"_bdea104d","paragraph":"_20578e23"};